'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _keyCodes = require('helpers/key-codes');

var _keyCodes2 = _interopRequireDefault(_keyCodes);

var _Button = require('components/Button/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./EditableField.scss');

var EditableField = (_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(EditableField, _Component);

  function EditableField() {
    var _ref;

    (0, _classCallCheck3.default)(this, EditableField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = EditableField.__proto__ || (0, _getPrototypeOf2.default)(EditableField)).call.apply(_ref, [this].concat(args)));

    _this.state = { isEdited: false, newValue: _this.props.value };
    return _this;
  }

  (0, _createClass3.default)(EditableField, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value) {
        this.setState({ newValue: nextProps.value });
      }
    }
  }, {
    key: 'onSave',
    value: function onSave() {
      var onSave = this.props.onSave;
      var newValue = this.state.newValue;

      this.setState({ isEdited: false });
      onSave(newValue);
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      if (e.which === _keyCodes2.default.cancel) {
        this.setState({ isEdited: false, newValue: this.props.value });
      } else {
        this.setState({ newValue: e.target.value });
        if (e.which === _keyCodes2.default.enter) {
          this.onSave();
        }
      }
    }
  }, {
    key: 'onBlur',
    value: function onBlur() {
      if (this.props.saveOnBlur) {
        this.onSave();
      }
    }
  }, {
    key: 'edit',
    value: function edit() {
      this.setState({ isEdited: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          iconClass = _props.iconClass,
          textClass = _props.textClass,
          inputClass = _props.inputClass,
          value = _props.value,
          okIconClass = _props.okIconClass,
          containerClass = _props.containerClass,
          loading = _props.loading,
          inputProps = _props.inputProps,
          type = _props.type;
      var _state = this.state,
          isEdited = _state.isEdited,
          newValue = _state.newValue;

      var inputType = type || (typeof value === 'number' ? 'number' : 'text');

      if (isEdited) {
        return _react2.default.createElement(
          'div',
          { className: className },
          _react2.default.createElement(
            'span',
            { className: (0, _classnames2.default)(styles.inputContainer, containerClass) },
            _react2.default.createElement('input', (0, _extends3.default)({
              type: inputType,
              value: newValue,
              onChange: this.onChange,
              className: inputClass,
              autoFocus: true,
              onKeyDown: this.onChange,
              onBlur: this.onBlur
            }, inputProps)),
            _react2.default.createElement('i', { className: (0, _classnames2.default)(okIconClass, styles.okIcon), onClick: this.onSave })
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          'span',
          { className: textClass },
          value
        ),
        _react2.default.createElement(_Button2.default, { className: (0, _classnames2.default)(styles.editIcon, iconClass), onClick: this.edit, loading: loading, small: true })
      );
    }
  }]);
  return EditableField;
}(_react.Component), _class2.propTypes = {
  className: _propTypes2.default.string,
  containerClass: _propTypes2.default.string,
  iconClass: _propTypes2.default.string,
  inputClass: _propTypes2.default.string,
  inputProps: _propTypes2.default.object,
  loading: _propTypes2.default.bool,
  okIconClass: _propTypes2.default.string,
  onSave: _propTypes2.default.func,
  saveOnBlur: _propTypes2.default.bool,
  textClass: _propTypes2.default.string,
  type: _propTypes2.default.string,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
}, _class2.defaultProps = {
  inputProps: {},
  okIconClass: 'icon-check',
  onSave: _noop3.default,
  saveOnBlur: true
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onSave', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onSave'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onChange'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onBlur', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onBlur'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'edit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'edit'), _class.prototype)), _class);
exports.default = EditableField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EditableField/EditableField.js
// module id = 821
// module chunks = 1